import { render, staticRenderFns } from "./ActManagement.vue?vue&type=template&id=6c9758e0&"
import script from "./ActManagement.vue?vue&type=script&lang=js&"
export * from "./ActManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports